import moment from "moment/moment";

export const calculateFuelUsed = (data) => {
    let fuelUsed = 0;
    for (let i = 1; i < data.length; i++) {
        const prev = data[i - 1]?.DeviceMonitorParameterValue?.value?.can_fuel_level;
        const current = data[i]?.DeviceMonitorParameterValue?.value?.can_fuel_level;

        if (current < prev) {
            fuelUsed += prev - current;
        }
    }

    return fuelUsed;
};

export function calculateDurations(data) {
    let runTime = 0;
    let pauseTime = 0;
    let stopTime = 0;

    for (let i = 1; i < data.length; i++) {
        const prevPoint = data[i - 1];
        const currPoint = data[i];

        // Convert timestamps to Date objects
        const prevTime = new Date(prevPoint.timestamp);
        const currTime = new Date(currPoint.timestamp);

        // Calculate duration in minutes
        const duration = (currTime - prevTime);

        // Categorize based on previous point's status
        if (prevPoint.status == 'Moving') {
            runTime += duration;
        } else if (prevPoint.status == 'Idle') {
            pauseTime += duration;
        } else if (prevPoint.status_type_id === 54) {
            stopTime += duration;
        }
    }

    return { runTime, pauseTime, stopTime };
}

export function calculateGeofenceTimes(points) {
    const geofenceTimes = {};

    for (const point of points) {
        const event = point.GeofenceEvent;
        const geofence = point.Geofence;

        if (event && geofence) {
            const name = geofence.name;
            const eventTime = new Date(event.event_time);

            if (!geofenceTimes[name]) {
                geofenceTimes[name] = {
                    enter: null,
                    exit: null,
                    duration: 0 // in seconds
                };
            }

            if (['enter', 'inside'].includes(event.event_type)) {
                if (!geofenceTimes[name].enter) {
                    geofenceTimes[name].enter = eventTime;
                } else {
                    const durationSeconds = (eventTime - geofenceTimes[name].enter) / 1000;
                    geofenceTimes[name].duration += durationSeconds;
                    geofenceTimes[name].enter = eventTime;
                }
            }
            else if (event.event_type === "exit") {
                geofenceTimes[name].exit = eventTime;

                if (geofenceTimes[name].enter) {
                    const durationSeconds = (eventTime - geofenceTimes[name].enter) / 1000;
                    geofenceTimes[name].duration += durationSeconds;

                    // Reset for next session
                    geofenceTimes[name].enter = null;
                }
            }
        }
    }
    // Format duration
    for (const name in geofenceTimes) {
        const d = geofenceTimes[name].duration;
        const minutes = Math.floor(d / 60);
        const seconds = Math.floor(d % 60);
        if (minutes >= 60) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            geofenceTimes[name].readableDuration = `${hours}h ${remainingMinutes}m ${seconds}s`;
        } else {
            geofenceTimes[name].readableDuration = `${minutes}m ${seconds}s`;
        }
    }

    return geofenceTimes;
}

export function getDuration(durationMs) {
    let durationStr = '';
    const durationDays = Math.floor(durationMs / (1000 * 60 * 60 * 24));
    const durationHours = Math.floor((durationMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const durationMinutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

    if (durationDays > 0) durationStr += `${durationDays}d `;
    if (durationHours > 0) durationStr += `${durationHours}h `;
    if (durationMinutes > 0) durationStr += `${durationMinutes}m`;
    if (durationStr === '') durationStr = 'Less than 1m';

    return durationStr
}

export function getTimezoneOffsetString() {
    const offset = new Date().getTimezoneOffset(); // in minutes
    const absoluteOffset = Math.abs(offset);
    const sign = offset <= 0 ? '+' : '-';
    const hours = String(Math.floor(absoluteOffset / 60)).padStart(2, '0');
    const minutes = String(absoluteOffset % 60).padStart(2, '0');
    return `${sign}${hours}:${minutes}`;
}

export function convertTo24HourRange(rangeStr) {
    const parseTime = (timeStr) => {
        const match = timeStr.trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?(am|pm)$/);
        if (!match) throw new Error("Invalid time format: " + timeStr);

        let [_, hour, minute, period] = match;
        hour = parseInt(hour);
        minute = parseInt(minute || "00");

        if (period === "pm" && hour !== 12) hour += 12;
        if (period === "am" && hour === 12) hour = 0;

        const timeString = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        const todayWithTime = moment(timeString, 'HH:mm').set({
            year: moment().year(),
            month: moment().month(),
            date: moment().date()
        });

        return todayWithTime.toDate();
    };

    const parts = rangeStr.split("-");
    if (parts.length === 2) {
        return [parseTime(parts[0]), parseTime(parts[1])];
        // return `${parseTime(parts[0])}-${parseTime(parts[1])}`;
    } else {
        return parseTime(rangeStr); // single time like "3pm"
    }
}
